module.exports = __webpack_public_path__ + "static/media/logo_hotel.e6c1a7c9.png";